import { render, staticRenderFns } from "./RealEstateManualListingsListCard.vue?vue&type=template&id=72014238"
import script from "./RealEstateManualListingsListCard.vue?vue&type=script&lang=ts"
export * from "./RealEstateManualListingsListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports